// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { Availability, CoOwnedProject, CoOwnerSummary, Overview, ProjectSummary, ShareSummary, SourceSummary, StoreSummary } from "../dataConsole/dto.generated";
import type { DataShareResponse } from "../dataShare/dto.generated";
export const addTagTypes = ["data-console"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiProjectsByProjectIdCoOwnedSources: build.query<
        GetApiProjectsByProjectIdCoOwnedSourcesApiResponse,
        GetApiProjectsByProjectIdCoOwnedSourcesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/co-owned-sources`,
        }),
        providesTags: ["data-console"],
      }),
      getApiWorkspacesByIdDataConsole: build.query<
        GetApiWorkspacesByIdDataConsoleApiResponse,
        GetApiWorkspacesByIdDataConsoleApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/data-console`,
        }),
        providesTags: ["data-console"],
      }),
      getApiWorkspacesByIdDataConsoleAvailability: build.query<
        GetApiWorkspacesByIdDataConsoleAvailabilityApiResponse,
        GetApiWorkspacesByIdDataConsoleAvailabilityApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/data-console/availability`,
        }),
        providesTags: ["data-console"],
      }),
      postApiWorkspacesByIdDataConsoleCoOwners: build.mutation<
        PostApiWorkspacesByIdDataConsoleCoOwnersApiResponse,
        PostApiWorkspacesByIdDataConsoleCoOwnersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/data-console/co-owners`,
          method: "POST",
          body: queryArg.dataconsoleCreateCoOwnerRequest,
        }),
        invalidatesTags: ["data-console"],
      }),
      deleteApiWorkspacesByIdDataConsoleCoOwnersAndGrantId: build.mutation<
        DeleteApiWorkspacesByIdDataConsoleCoOwnersAndGrantIdApiResponse,
        DeleteApiWorkspacesByIdDataConsoleCoOwnersAndGrantIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/data-console/co-owners/${encodeURIComponent(String(queryArg.grantId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["data-console"],
      }),
      postApiWorkspacesByIdDataConsoleShares: build.mutation<
        PostApiWorkspacesByIdDataConsoleSharesApiResponse,
        PostApiWorkspacesByIdDataConsoleSharesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/data-console/shares`,
          method: "POST",
          body: queryArg.dataconsoleCreateShareRequest,
        }),
        invalidatesTags: ["data-console"],
      }),
      deleteApiWorkspacesByIdDataConsoleSharesAndDataShareId: build.mutation<
        DeleteApiWorkspacesByIdDataConsoleSharesAndDataShareIdApiResponse,
        DeleteApiWorkspacesByIdDataConsoleSharesAndDataShareIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/data-console/shares/${encodeURIComponent(String(queryArg.dataShareId))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["data-console"],
      }),
      patchApiWorkspacesByIdDataConsoleSharesAndDataShareId: build.mutation<
        PatchApiWorkspacesByIdDataConsoleSharesAndDataShareIdApiResponse,
        PatchApiWorkspacesByIdDataConsoleSharesAndDataShareIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/data-console/shares/${encodeURIComponent(String(queryArg.dataShareId))}`,
          method: "PATCH",
          body: queryArg.dataSharesUpdateDataShareRequest,
        }),
        invalidatesTags: ["data-console"],
      }),
      postApiWorkspacesByIdDataConsoleStore: build.mutation<
        PostApiWorkspacesByIdDataConsoleStoreApiResponse,
        PostApiWorkspacesByIdDataConsoleStoreApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/data-console/store`,
          method: "POST",
        }),
        invalidatesTags: ["data-console"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as dataConsoleApi };
export type GetApiProjectsByProjectIdCoOwnedSourcesApiResponse =
  /** status 200 OK */ { data: DataconsoleCoOwnedProject[] };
export type GetApiProjectsByProjectIdCoOwnedSourcesApiArg = {
  /** Project ID */
  projectId: string;
};
export type GetApiWorkspacesByIdDataConsoleApiResponse =
  /** status 200 OK */ { data: DataconsoleOverview };
export type GetApiWorkspacesByIdDataConsoleApiArg = {
  /** Workspace ID */
  id: string;
};
export type GetApiWorkspacesByIdDataConsoleAvailabilityApiResponse =
  /** status 200 OK */ { data: DataconsoleAvailability };
export type GetApiWorkspacesByIdDataConsoleAvailabilityApiArg = {
  /** Workspace ID */
  id: string;
};
export type PostApiWorkspacesByIdDataConsoleCoOwnersApiResponse =
  /** status 201 Created */ { data: DataconsoleCoOwnerSummary };
export type PostApiWorkspacesByIdDataConsoleCoOwnersApiArg = {
  /** Workspace ID */
  id: string;
  /** Provider and grantee projects */
  dataconsoleCreateCoOwnerRequest: DataconsoleCreateCoOwnerRequest;
};
export type DeleteApiWorkspacesByIdDataConsoleCoOwnersAndGrantIdApiResponse =
  /** status 200 OK */ {
    [key: string]: any;
  };
export type DeleteApiWorkspacesByIdDataConsoleCoOwnersAndGrantIdApiArg = {
  /** Workspace ID */
  id: string;
  /** Co-owner grant ID */
  grantId: string;
};
export type PostApiWorkspacesByIdDataConsoleSharesApiResponse =
  /** status 201 Created */ { data: DataSharesDataShareResponse };
export type PostApiWorkspacesByIdDataConsoleSharesApiArg = {
  /** Workspace ID */
  id: string;
  /** Share between two workspace projects */
  dataconsoleCreateShareRequest: DataconsoleCreateShareRequest;
};
export type DeleteApiWorkspacesByIdDataConsoleSharesAndDataShareIdApiResponse =
  /** status 200 OK */ {
    [key: string]: any;
  };
export type DeleteApiWorkspacesByIdDataConsoleSharesAndDataShareIdApiArg = {
  /** Workspace ID */
  id: string;
  /** Data Share ID */
  dataShareId: string;
};
export type PatchApiWorkspacesByIdDataConsoleSharesAndDataShareIdApiResponse =
  /** status 200 OK */ { data: DataSharesDataShareResponse };
export type PatchApiWorkspacesByIdDataConsoleSharesAndDataShareIdApiArg = {
  /** Workspace ID */
  id: string;
  /** Data Share ID */
  dataShareId: string;
  /** Update request */
  dataSharesUpdateDataShareRequest: DataSharesUpdateDataShareRequest;
};
export type PostApiWorkspacesByIdDataConsoleStoreApiResponse =
  /** status 200 OK */ { data: DataconsoleStoreSummary };
export type PostApiWorkspacesByIdDataConsoleStoreApiArg = {
  /** Workspace ID */
  id: string;
};
export type DataconsoleSourceSummary = SourceSummary;
export type DataconsoleCoOwnedProject = CoOwnedProject;
export type DataconsoleCoOwnerSummary = CoOwnerSummary;
export type DataconsoleProjectSummary = ProjectSummary;
export type DataconsoleShareSummary = ShareSummary;
export type DataconsoleOverview = Overview;
export type DataconsoleAvailability = Availability;
export type DataconsoleCreateCoOwnerRequest = {
  grantee_project_id?: string;
  provider_project_id?: string;
};
export type DataSharesDataShareResponse = DataShareResponse;
export type DataconsoleCreateShareRequest = {
  consumer_project_id?: string;
  expires_at?: string;
  provider_project_id?: string;
  table_names?: string[];
};
export type DataSharesUpdateDataShareRequest = {
  expires_at?: string;
  table_names?: string[];
};
export type DataconsoleStoreSummary = StoreSummary;
export const {
  useGetApiProjectsByProjectIdCoOwnedSourcesQuery,
  useLazyGetApiProjectsByProjectIdCoOwnedSourcesQuery,
  useGetApiWorkspacesByIdDataConsoleQuery,
  useLazyGetApiWorkspacesByIdDataConsoleQuery,
  useGetApiWorkspacesByIdDataConsoleAvailabilityQuery,
  useLazyGetApiWorkspacesByIdDataConsoleAvailabilityQuery,
  usePostApiWorkspacesByIdDataConsoleCoOwnersMutation,
  useDeleteApiWorkspacesByIdDataConsoleCoOwnersAndGrantIdMutation,
  usePostApiWorkspacesByIdDataConsoleSharesMutation,
  useDeleteApiWorkspacesByIdDataConsoleSharesAndDataShareIdMutation,
  usePatchApiWorkspacesByIdDataConsoleSharesAndDataShareIdMutation,
  usePostApiWorkspacesByIdDataConsoleStoreMutation,
} = injectedRtkApi;
